import React, { useEffect, useCallback } from 'react';

interface GameWrapperProps {
  isModalOpen: boolean;
  onRestart: () => void;
  children: React.ReactNode;
}

export const GameWrapper: React.FC<GameWrapperProps> = ({ isModalOpen, onRestart, children }) => {
  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    // GUARD: If modal is open, prevent the game from restarting on spacebar
    if (isModalOpen) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.code === 'Space') {
      event.preventDefault();
      onRestart();
    }
  }, [isModalOpen, onRestart]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className={`relative ${isModalOpen ? 'pointer-events-none opacity-50' : 'pointer-events-auto'}`}>
      {children}
    </div>
  );
};
